// extracted by mini-css-extract-plugin
export default {"form":"styles_form__NujgW","submit":"styles_submit__e9lsw","clear":"styles_clear__8QJyu"};